import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowRight } from "react-icons/fa";
import "./VendorService.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { CiLocationOn } from "react-icons/ci";
import ComingSoonModel from "../Modal/ComingSoonModel";
import { Container } from "react-bootstrap";

const VendorService = ({ vendors }) => {
  const vendorData = vendors?.childes || [];

  if (!vendors || vendorData.length === 0) {
    return null;
  }

  const sliderSettings = {
    infinite: false,
    dots: false,
    speed: 500,
    initialSlide: 0,
    slidesToShow: 3,
    // slidesToShow: Math.min(3, vendorData.length),
    slidesToScroll: 1,
    arrows: vendorData.length > 2,
    // centerMode: true,  
    // centerPadding: "40px",  
    prevArrow: <FontAwesomeIcon icon={faAngleLeft} className="prev-arrow" />,
    nextArrow: <FontAwesomeIcon icon={faAngleRight} className="next-arrow" />,
    // className: "center",  
    // variableWidth: false,  
    responsive: [
      {
        breakpoint: 1190,
        settings: {
          slidesToShow: Math.min(2, vendorData.length),
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <div className="vendorService" style={{ backgroundColor: "#F9F9F9" }}>
      <Container>
        <div className="row text-start mb-4">
          <h4>Meet Our Service Provider</h4>
        </div>
        <div className="mt-3">
          <Slider {...sliderSettings}>
            {vendorData.map((service, index) => (
              <div key={index} className="slick-slide p-2">
                <div
                  className="card"
                  style={{
                    width: "100%",
                    height: "18.5rem",
                    margin: "0px 0px",
                  }}
                >
                  <img
                    src={service.image}
                    className="card-img-top"
                    style={{
                      backgroundColor: "#D8E7FF",
                      height: "140px",
                      objectFit: "contain",
                    }}
                    // alt={service.vendor_name}
                  />
                  <div className="card-body">
                    <span
                      className="card-text fw-bolder"
                      style={{ fontSize: "14px" }}
                    >
                      {service.vendor_name}
                    </span>
                    <div className="d-flex">
                      <CiLocationOn className="fs-2 mt-1" />
                      <p
                        className="mt-2"
                        style={{ fontSize: "12px", marginLeft: "10px" }}
                      >
                        {service.address}
                      </p>
                    </div>
                    <button
                      className="btn w-100 border-black"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="d-flex justify-content-center mt-5">
            <button
              type="button"
              className="btn btn-dark"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              View More <FaArrowRight />
            </button>
            <ComingSoonModel modalId="exampleModal" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default VendorService;
